import { Server } from 'socket.io';
import { AuthSocket } from '../socket.bootstrap';
import { SocketEvents } from '@ichat/shared-types';
import { prisma } from '../../shared/prisma';

export function webrtcHandler(io: Server, socket: AuthSocket) {
  
  const handleOffer = async (data: { toUserId: string, offer: any, callerInfo?: any, callType?: string }) => {
    console.log(`📡 [WebRTC] CALL_OFFER from ${socket.userId} to ${data.toUserId}`);
    
    let displayName = socket.displayName || data.callerInfo?.displayName;
    let username = socket.username || data.callerInfo?.username;

    if (!displayName || displayName === 'User') {
      try {
        const user = await prisma.user.findUnique({
          where: { id: socket.userId },
          select: { displayName: true, username: true }
        });
        if (user) {
          displayName = user.displayName || user.username;
          username = user.username;
        }
      } catch (err) {
        console.warn('Error fetching caller details for WebRTC offer:', err);
      }
    }

    let roomName = '';
    let callType = 'audio';

    if (data.offer && typeof data.offer === 'object') {
      roomName = data.offer.roomName || '';
      callType = data.offer.callType || data.callType || 'audio';
    } else if (typeof data.offer === 'string') {
      roomName = data.offer;
      callType = (data as any).callType || 'audio';
    } else if (data.callType) {
      callType = data.callType;
    }

    if (roomName.includes('_audio_') || roomName.startsWith('room_audio_')) {
      callType = 'audio';
    } else if (roomName.includes('_video_') || roomName.startsWith('room_video_')) {
      callType = 'video';
    } else if (roomName.includes('_screen_') || roomName.startsWith('room_screen_')) {
      callType = 'screen';
    }

    const payload = {
      fromUserId: socket.userId,
      offer: data.offer,
      callType: callType,
      roomName: roomName,
      callerInfo: {
        id: socket.userId,
        displayName: displayName || username || 'Colleague',
        username: username || 'user'
      }
    };

    // Send the offer to the target user's personal room (both aliases)
    io.to(`user:${data.toUserId}`).to(data.toUserId).emit('call:offer', payload);
    io.to(`user:${data.toUserId}`).to(data.toUserId).emit('CALL_OFFER', payload);
  };

  const handleAnswer = (data: { toUserId: string, answer: any }) => {
    io.to(`user:${data.toUserId}`).to(data.toUserId).emit('call:answer', {
      fromUserId: socket.userId,
      answer: data.answer
    });
  };

  const handleCandidate = (data: { toUserId: string, candidate: any }) => {
    io.to(`user:${data.toUserId}`).to(data.toUserId).emit('call:ice_candidate', {
      fromUserId: socket.userId,
      candidate: data.candidate
    });
  };

  const handleEnd = (data: { toUserId: string }) => {
    io.to(`user:${data.toUserId}`).to(data.toUserId).emit('call:end', {
      fromUserId: socket.userId
    });
  };

  const handleRinging = (data: { toUserId: string }) => {
    io.to(`user:${data.toUserId}`).to(data.toUserId).emit('call:ringing', {
      fromUserId: socket.userId
    });
  };

  const handleRejected = (data: { toUserId: string }) => {
    io.to(`user:${data.toUserId}`).to(data.toUserId).emit('call:rejected', {
      fromUserId: socket.userId
    });
  };

  const handleAccepted = (data: { toUserId: string }) => {
    io.to(`user:${data.toUserId}`).to(data.toUserId).emit('call:accepted', {
      fromUserId: socket.userId
    });
  };

  socket.on('call:offer', handleOffer);
  socket.on('CALL_OFFER', handleOffer);

  socket.on('call:answer', handleAnswer);
  socket.on('CALL_ANSWER', handleAnswer);

  socket.on('call:ice_candidate', handleCandidate);
  socket.on('CALL_ICE_CANDIDATE', handleCandidate);

  socket.on('call:end', handleEnd);
  socket.on('CALL_END', handleEnd);

  socket.on('call:ringing', handleRinging);
  socket.on('CALL_RINGING', handleRinging);

  socket.on('call:rejected', handleRejected);
  socket.on('CALL_REJECTED', handleRejected);

  socket.on('call:accepted', handleAccepted);
  socket.on('CALL_ACCEPTED', handleAccepted);
}
